import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  root: {
    maxWidth: '700px',
    margin: '0 auto',
  },
  footer: ({ isDownsized }) => ({
    padding: isDownsized ? '8px' : '25px',
    minHeight: '100%',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
  }),
  page: ({ isDownsized }) => ({
    padding: isDownsized ? '12px 8px 0px 8px' : '25px 16px 0px 16px',
  }),
  fullHeight: {
    height: '100%',
  },
});
